/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
};

class PayStrategy extends React.Component {
  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'billing');
  }
  render() {
    return (
      <div styleName="card-content">
        <ul className="list-unstyled">
          <li>
            <span styleName="tier">[1, 50]&nbsp;</span>
            {this.intlMsg.msg('pay.tier.txt1')}
            <span styleName="price">&nbsp;2RMB/{this.intlMsg.msg('pay.tier.bymonth')}</span>
            {this.intlMsg.msg('pay.tier.txt2')}
          </li>
          <li>
            <span styleName="tier">[51, 500]&nbsp;</span>
            {this.intlMsg.msg('pay.tier.txt1')}
            <span styleName="price">&nbsp;1.5RMB/{this.intlMsg.msg('pay.tier.bymonth')}</span>
            {this.intlMsg.msg('pay.tier.txt2')}
          </li>
          <li>
            <span styleName="tier">[501, 1000]&nbsp;</span>
            {this.intlMsg.msg('pay.tier.txt1')}
            <span styleName="price">&nbsp;1.2RMB/{this.intlMsg.msg('pay.tier.bymonth')}</span>
            {this.intlMsg.msg('pay.tier.txt2')}
          </li>
          <li>
            <span styleName="tier">1000&nbsp;</span>
            {this.intlMsg.msg('pay.tier.txt3')}
          </li>
        </ul>
      </div>
    );
  }
}

PayStrategy.propTypes = propTypes;

export default injectIntl(CSSModules(PayStrategy, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/containers/Billing/coms/PayStrategy/index.jsx